import React from 'react';
import { Box } from '@/components/gluestack/box';

interface CardWrapperProps {
  children: React.ReactNode;
}

/**
 * A consistent wrapper component for card elements
 * Used across various screens for consistent spacing and layout
 * 
 * @param children - The content to be wrapped
 */
export function CardWrapper({ children }: CardWrapperProps) {
  return (
    <Box className={`mt-3 px-3 md:px-4 md:mb-4 md:mt-0`}>{children}</Box>
  );
}
